import React from 'react';
import { useForm } from 'react-hook-form';
import {
    Box,
    Typography,
    RadioGroup,
    FormControlLabel,
    Radio,
    Button,
    FormControl,
    FormLabel,
    FormHelperText
} from '@mui/material';

const GoalSection = ({ onNext }) => {
    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            cel_wybor: '',
            zwrot_plec: ''
        }
    });

    const goalOptions = [
        "Szukam pierwszej pracy",
        "Szukam pracy",
        "Myślę o znalezieniu innej/nowej pracy",
        "Wracam na rynek pracy",
        "Przekwalifikowuje się"
    ];

    const genderOptions = [
        "On",
        "Ona",
        "Neutralnie płciowo _"
    ];

    return (
        <Box component="form" onSubmit={handleSubmit(onNext)} sx={{ mt: 3 }}>
            <FormControl component="fieldset" error={!!errors.cel_wybor} fullWidth sx={{ mb: 3 }}>
                <FormLabel component="legend">
                    <Typography variant="h6" color="black">
                        W czym mogę Ci dzisiaj pomóc?
                    </Typography>
                </FormLabel>
                <RadioGroup
                    aria-label="cel"
                    name="cel_wybor"
                >
                    {goalOptions.map((option) => (
                        <FormControlLabel
                            key={option}
                            value={option}
                            control={
                                <Radio
                                    {...register('cel_wybor', {
                                        required: "To pole jest wymagane"
                                    })}
                                />
                            }
                            label={option}
                        />
                    ))}
                </RadioGroup>
                {errors.cel_wybor && (
                    <FormHelperText>{errors.cel_wybor.message}</FormHelperText>
                )}
            </FormControl>

            <FormControl component="fieldset" error={!!errors.zwrot_plec} fullWidth sx={{ mb: 3 }}>
                <FormLabel component="legend">
                    <Typography variant="h6" color="black">
                        Jak się do Ciebie zwracać?
                    </Typography>
                </FormLabel>
                <RadioGroup
                    aria-label="zwrot-plec"
                    name="zwrot_plec"
                >
                    {genderOptions.map((option) => (
                        <FormControlLabel
                            key={option}
                            value={option}
                            control={
                                <Radio
                                    {...register('zwrot_plec', {
                                        required: "To pole jest wymagane"
                                    })}
                                />
                            }
                            label={option}
                        />
                    ))}
                </RadioGroup>
                {errors.zwrot_plec && (
                    <FormHelperText>{errors.zwrot_plec.message}</FormHelperText>
                )}
            </FormControl>

            <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
            >
                Dalej
            </Button>
        </Box>
    );
};

export default GoalSection; 